/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaAudioWaveIcon16Light = forwardRef('MediaAudioWaveIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M7 2a.5.5 0 0 0-1 0v12a.5.5 0 0 0 1 0V2Z" }),
        React.createElement("path", { d: "M13 4a.5.5 0 0 0-1 0v8a.5.5 0 0 0 1 0V4Z" }),
        React.createElement("path", { d: "M16 6.5a.5.5 0 0 0-1 0v3a.5.5 0 0 0 1 0v-3Z" }),
        React.createElement("path", { d: "M9.5 5.25a.5.5 0 0 1 .5.5v4.5a.5.5 0 0 1-1 0v-4.5a.5.5 0 0 1 .5-.5Z" }),
        React.createElement("path", { d: "M3.5 4.25a.5.5 0 0 1 .5.5v6.5a.5.5 0 0 1-1 0v-6.5a.5.5 0 0 1 .5-.5Z" }),
        React.createElement("path", { d: "M1 7a.5.5 0 0 0-1 0v2a.5.5 0 0 0 1 0V7Z" })));
});
